import styled from 'styled-components';
import { Text } from '../../design/Text';
import { Container } from '../../design/Container';
import { Button } from '../../design/Button';

export const IntroContainer = styled(Container)`
  align-items: center;
  justify-content: space-between;
  height: 90vh;
  width: 100vw;
`;

export const Wrapper = styled.div`
  top: 0;
  left: 0;
  height: 90vh
`;

export const ImgHolder = styled.div`
  margin-top: 30px;
  width: 100vw;
  height: 36vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const Img = styled.img`
  height: 100%;
  width: auto;
`;

export const SlideContainer = styled(Container)`
  width: calc(100vw - 28px);
  padding: 0 14px;
  overflow: hidden;
`;

export const SubText = styled(Text)`
  width: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  
`;

export const Back = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  height: 20px;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IntroButton = styled(Button)`
  position: absolute;
  top: calc(100% - 78px);
  left: 50%;
  transform: translateX(-50%);
  width: calc(100vw - 32px);
`;
